import { ChangeDetectionStrategy, Component, OnInit, computed, effect, inject, input, signal } from '@angular/core';

import { EntityTypeEnum } from '../../models/enums/entity-type.enum';
import { FavoriteModel } from '../../models/favorite.model';
import { FavoritesResource } from '../../services/resources/favorites.resource';

@Component({
    selector: 'sl-favorites',
    templateUrl: './favorites.component.html',
    styleUrls: ['./favorites.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FavoritesComponent implements OnInit {
    id = input.required<string>();
    type = input.required<EntityTypeEnum>();

    isFavorite = signal(false);
    isLoading = signal(false);
    currentFavorite: FavoriteModel;
    readonly buttonColor = computed(() => (this.isFavorite() ? 'accent' : 'primary'));

    private readonly favoritesResource = inject(FavoritesResource);

    constructor() {
        effect(
            () => {
                this.id();
                this.type();
                this.loadLocalData();
            },
            { allowSignalWrites: true }
        );
    }

    ngOnInit(): void {
        this.loadLocalData();
    }

    toggleFavorite(): void {
        if (this.isFavorite()) {
            this.favoritesResource.remove(this.currentFavorite).subscribe(() => this.isFavorite.set(false));
        } else {
            this.favoritesResource.add(this.currentFavorite).subscribe(() => this.isFavorite.set(true));
        }
    }

    private loadLocalData(): void {
        this.isLoading.set(true);
        this.currentFavorite = new FavoriteModel({ recordId: +this.id(), tableName: this.type() });

        this.favoritesResource.exists(this.currentFavorite).subscribe(r => {
            this.isFavorite.set(r.value);
            this.isLoading.set(false);
        });
    }
}
